export default "__VITE_ASSET__jfEX$wc2__"